import React, { Component } from "react";
import { observer } from "mobx-react";
import { computed } from "mobx";
import PropTypes from "prop-types";
import { Table } from "semantic-ui-react";
import CreditCostText from "../../../spa/component/ui/CreditCostText";
import TourJobType from "~/constants/TourJob/TourJobType";
import ProductId from "~/constants/ProductId";

@observer
class PriceTableForPricingMethodFlatFee extends Component {
  @computed
  get hasRequestedFloorPlan() {
    const { tourJobTypeId } = this.props;

    return tourJobTypeId === TourJobType.IMMERSIVE_3D_TOUR_PANORAMAS_WITH_FLOOR_PLAN;
  }

  /**
   * @returns {number}
   */
  @computed
  get totalCreditCost() {
    const { panoramasCount, productDiscountedCreditCosts } = this.props;

    // Everything has been paid already
    if (panoramasCount > 0) {
      return 0;
    }

    const publishTourCreditCost = productDiscountedCreditCosts[ProductId.PUBLISH_TOUR];
    const immersive3dTourCreditCost = productDiscountedCreditCosts[ProductId.IMMERSIVE_3D_TOUR];
    const floorPlanCreditCost = productDiscountedCreditCosts[ProductId.FLOOR_PLAN];

    if (!this.hasRequestedFloorPlan) {
      return publishTourCreditCost + immersive3dTourCreditCost;
    }

    return publishTourCreditCost + immersive3dTourCreditCost + floorPlanCreditCost;
  }

  render() {
    const { panoramasCount, newPanoramasCount, productDiscountedCreditCosts } = this.props;

    const publishTourCreditCost = productDiscountedCreditCosts[ProductId.PUBLISH_TOUR];
    const immersive3dTourCreditCost = productDiscountedCreditCosts[ProductId.IMMERSIVE_3D_TOUR];
    const floorPlanCreditCost = productDiscountedCreditCosts[ProductId.FLOOR_PLAN];

    return (
      <>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Summary</Table.HeaderCell>
              <Table.HeaderCell>New</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>Panoramas</Table.Cell>
              <Table.Cell>{newPanoramasCount}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Immersive 3D Tour</Table.Cell>
              <Table.Cell>
                {panoramasCount === 0 ? (
                  <CreditCostText cost={publishTourCreditCost + immersive3dTourCreditCost} />
                ) : (
                  "PAID"
                )}
              </Table.Cell>
            </Table.Row>
            {this.hasRequestedFloorPlan && (
              <Table.Row>
                <Table.Cell>Floor Plan</Table.Cell>
                <Table.Cell>{panoramasCount === 0 ? <CreditCostText cost={floorPlanCreditCost} /> : "PAID"}</Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell>
                <strong>Total</strong>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <strong>
                  <CreditCostText cost={this.totalCreditCost} />
                </strong>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
        <p>The price for an Immersive 3D Tour is:</p>
        <Table celled textAlign="center">
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <strong>Immersive 3D Tour</strong>
                <br />
                <CreditCostText cost={publishTourCreditCost + immersive3dTourCreditCost} />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <strong>Floor plan</strong>
                <br />
                <CreditCostText cost={floorPlanCreditCost} />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </>
    );
  }
}

PriceTableForPricingMethodFlatFee.propTypes = {
  tourJobTypeId: PropTypes.number.isRequired,
  panoramasCount: PropTypes.number.isRequired,
  newPanoramasCount: PropTypes.number.isRequired,
  productDiscountedCreditCosts: PropTypes.shape({
    [ProductId.PUBLISH_TOUR]: PropTypes.number.isRequired,
    [ProductId.IMMERSIVE_3D_TOUR]: PropTypes.number.isRequired,
    [ProductId.FLOOR_PLAN]: PropTypes.number.isRequired,
  }).isRequired,
};

export default PriceTableForPricingMethodFlatFee;
